<template>
  <Dialog :title="null" variant="narrow" @close="emit('close')">
    <p class="subscription-success-message">
      {{ t("web.subscription.message.confirmation_email_sent") }}
      <strong>{{ emailAddress }}</strong
      >.
    </p>
    <template #actions>
      <a
        v-if="sniperLink"
        :href="sniperLink.url"
        target="_blank"
        rel="noopener noreferrer"
        class="subscription-success-button"
      >
        {{ t("web.action.take_me_to") }} {{ sniperLink.provider_pretty }}
      </a>
      <button
        type="button"
        class="subscription-success-button"
        @click="emit('close')"
      >
        {{ t("web.button.got_it") }}
      </button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/design_system/shared/Dialog/Dialog.vue";
import type { Newsletter } from "@/types/newsletter";

import { createTranslator } from "../../lib/utils";

interface SniperLink {
  url: string;
  provider_pretty: string;
}

const emit = defineEmits<{
  close: [];
}>();

const props = defineProps<{
  newsletter: Newsletter;
  emailAddress: string;
  sniperLink: SniperLink | null;
}>();

const t = createTranslator(() => props.newsletter.locale);
</script>
